// src/pages/AssignShippingService.jsx
import React, { useState, useEffect } from 'react';
import { PiPencilBold } from 'react-icons/pi';
 
const AssignShippingService = () => {
  const [shippingTypes, setShippingTypes] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedShippingType, setSelectedShippingType] = useState('');
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userLabId, setUserLabId] = useState(null);
 
  /* ------------------------------------------------------------------ */
  /* GET USERLABID ON COMPONENT MOUNT                                  */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const labId = localStorage.getItem('userLabId');
    setUserLabId(labId); // Note: labId might be null if not in localStorage
  }, []);
 
  /* ------------------------------------------------------------------ */
  /* FETCH DATA (MODIFIED LOGIC)                                       */
  /* ------------------------------------------------------------------ */
 
  const fetchShippingTypes = async (labId) => {
    try {
      // Logic: If labId exists, filter by it. Otherwise fetch ALL.
      let url = 'https://hms.backend.hiragroupcloud.com/api/shipping';
      if (labId) {
        url += `?addedBy=${labId}`;
      }
     
      const res = await fetch(url);
      const json = await res.json();
     
      if (json.success && Array.isArray(json.data)) {
        setShippingTypes(json.data);
        return true;
      } else {
        setError('Failed to load shipping types');
        return false;
      }
    } catch (e) {
      setError('Network error: ' + e.message);
      return false;
    }
  };
 
  const fetchAccounts = async (labId) => {
    try {
      let url = '';
      if (labId) {
        // Fetch only Lab Specific Accounts
        url = `https://hms.backend.hiragroupcloud.com/api/account/lab-accounts/${labId}`;
      } else {
        // Fetch ALL Accounts (using your existing /account route)
        url = `https://hms.backend.hiragroupcloud.com/api/account/account`;
      }
 
      const res = await fetch(url);
      const json = await res.json();
 
      // Check for success (Your /account API returns { data: [...] })
      if (res.ok && (json.success || json.message === 'Data fetched successfully.') && Array.isArray(json.data)) {
        setAccounts(json.data);
        return true;
      } else {
        setError(json.message || 'Failed to load accounts');
        return false;
      }
    } catch (e) {
      setError('Network error: ' + e.message);
      return false;
    }
  };
 
  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      setError(null);
     
      const labId = localStorage.getItem('userLabId');
     
      // Dono functions ko labId pass kar rahe hain (jo null bhi ho sakta hai)
      const shippingSuccess = await fetchShippingTypes(labId);
      const accountsSuccess = await fetchAccounts(labId);
     
      setLoading(false);
    };
 
    fetchAllData();
  }, []); // Run once on mount
 
  /* ------------------------------------------------------------------ */
  /* CHECKBOX LOGIC                                                    */
  /* ------------------------------------------------------------------ */
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedAccounts([]);
    } else {
      setSelectedAccounts(accounts.map((a) => a._id));
    }
    setSelectAll(!selectAll);
  };
 
  const handleAccountToggle = (id) => {
    const newSel = selectedAccounts.includes(id)
      ? selectedAccounts.filter((x) => x !== id)
      : [...selectedAccounts, id];
 
    setSelectedAccounts(newSel);
    setSelectAll(newSel.length === accounts.length && accounts.length > 0);
  };
 
  /* ------------------------------------------------------------------ */
  /* SAVE                                                              */
  /* ------------------------------------------------------------------ */
  const handleSave = async () => {
    if (!selectedShippingType) return alert('Select a shipping type');
    if (selectedAccounts.length === 0) return alert('Select at least one account');
 
    const payload = {
      shippingTypeId: selectedShippingType,
      accountIds: selectedAccounts,
    };
 
    try {
      const res = await fetch('https://hms.backend.hiragroupcloud.com/api/shipping/assign', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const json = await res.json();
 
      if (res.ok && json.success) {
        alert('Assigned successfully!');
        // Refresh account list
        fetchAccounts(userLabId);
        setSelectedAccounts([]);
        setSelectAll(false);
      } else {
        alert('Failed: ' + (json.message || 'unknown'));
      }
    } catch (e) {
      alert('Save error: ' + e.message);
    }
  };
 
  /* ------------------------------------------------------------------ */
  /* RENDER                                                            */
  /* ------------------------------------------------------------------ */
  if (loading) {
    return <div style={{ textAlign: 'center', padding: '60px' }}>Loading…</div>;
  }
 
  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '60px', color: 'red' }}>
        {error}
        <button onClick={() => window.location.reload()} style={{ marginLeft: '10px' }}>
          Retry
        </button>
      </div>
    );
  }
 
  return (
    <>
      <div style={{ marginBottom: '25px' }}></div>
 
      <div style={{ width: '95%', margin: '0 auto' }}>
        <div className="row">
          <div className="col-md-10">
            <h1 style={{ marginBottom: '20px' }}>Assign Shipping Service</h1>
 
            {/* ---- SHIPPING TYPE ---- */}
            <h2 style={{ color: '#004aad', marginBottom: '10px' }}>Shipping Types</h2>
            <div
              style={{
                backgroundColor: '#f4f4f4',
                padding: '15px',
                borderTop: '2px solid #004aad',
                marginBottom: '20px',
              }}
            >
              <label style={{ marginRight: '10px', fontWeight: 500 }}>
                Shipping Type <span style={{ color: 'red' }}>*</span>
              </label>
              <select
                value={selectedShippingType}
                onChange={(e) => setSelectedShippingType(e.target.value)}
                style={{
                  padding: '8px 12px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  width: '300px',
                  fontSize: '14px',
                }}
              >
                <option value="">Select Shipping Type</option>
                {shippingTypes.map((t) => (
                  <option key={t._id} value={t._id}>
                    {t.service} ({t.company})
                  </option>
                ))}
              </select>
              {shippingTypes.length === 0 && (
                <div style={{ marginTop: '10px', color: '#666', fontSize: '14px' }}>
                  No shipping types found.
                </div>
              )}
            </div>
 
            {/* ---- ACCOUNTS ---- */}
            <h2 style={{ color: '#004aad', marginBottom: '10px' }}>
              Accounts {!userLabId && "(Showing All Systems)"}
            </h2>
            <div
              style={{
                backgroundColor: '#f4f4f4',
                padding: '15px',
                borderTop: '2px solid #004aad',
                maxHeight: '520px',
                overflowY: 'auto',
              }}
            >
              {accounts.length === 0 ? (
                <p style={{ color: '#888', fontStyle: 'italic' }}>No accounts found.</p>
              ) : (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', fontWeight: 'bold' }}>
                    <label style={{ width: '220px' }}>Select All</label>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      style={{ transform: 'scale(1.3)', marginRight: '8px' }}
                    />
                  </div>
 
                  {accounts.map((acc) => (
                    <div
                      key={acc._id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '10px',
                        padding: '6px 0',
                      }}
                    >
                      <label
                        style={{
                          width: '220px',
                          fontSize: '14px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                        title={acc.account_name}
                      >
                        {acc.account_name}
                      </label>
 
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="checkbox"
                          checked={selectedAccounts.includes(acc._id)}
                          onChange={() => handleAccountToggle(acc._id)}
                          style={{ transform: 'scale(1.1)', marginRight: '8px' }}
                        />
 
                        {acc.shippingService && (
                          <span
                            style={{
                              color: '#004aad',
                              fontSize: '12px',
                              fontWeight: '500',
                            }}
                            title={`Company: ${acc.shippingService.company}`}
                          >
                            {acc.shippingService.service}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              )}
             
              <p style={{color:'#979696ff',fontStyle:'italic', marginTop:'15px'}}>
                This will remove account level transit days overrides.
              </p>
             
              <button
                onClick={handleSave}
                style={{
                  marginTop: '15px',
                  backgroundColor: '#004aad',
                  color: '#fff',
                  padding: '12px 22px',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <PiPencilBold style={{ marginRight: '8px', fontSize: '18px' }} />
                Save Assignment
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
 
export default AssignShippingService;
 